import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { deleteExpense } from "../../backend-services";
import { useTranslation } from "react-i18next";
import { showToast } from "../../utils/toastUtils";

interface ExpenseDeletePromptProps {
  showPrompt: boolean;
  onExpenseDelete?: (expenseId: any) => void;
  expenseId: string;
  onClose?: () => void;
  onDeleteSuccess?: () => void;
}

const ExpenseDeletePrompt = ({
  showPrompt,
  expenseId,
  onExpenseDelete,
  onClose,
  onDeleteSuccess,
}: ExpenseDeletePromptProps) => {
  const { t } = useTranslation("expenses");
  const [isDeleting, setIsDeleting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [isDeleted, setIsDeleted] = React.useState(false);
  const [showSuccessBanner, setShowSuccessBanner] = React.useState(false);

  const navigate = useNavigate();

  const handleDeleteExpense = async (id: string) => {
    setIsDeleting(true);
    try {
      const data = await deleteExpense(id);
      setIsDeleting(false);
      setIsDeleted(true);
      onExpenseDelete && onExpenseDelete(id);
      onDeleteSuccess && onDeleteSuccess();
      showToast("Expense successfully deleted!", "success");
    } catch (error: any) {
      setErrorMessage("Unable to Delete Expense.");
      setIsDeleting(false);
      if (
        error.expense &&
        (error.expense.status === 400 || error.expense.status === 500)
      ) {
        navigate("/error");
      }
    }
  };

  const handleKeepExpense = () => {
    onClose && onClose();
  };

  useEffect(() => {
    if (isDeleted) {
      setShowSuccessBanner(true);
      navigate("/expenses");
    }
  }, [isDeleted, navigate]);

  const closeSuccessSidebar = () => {
    setShowSuccessBanner(false);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white w-[474px] mx-5 p-4 rounded-lg shadow-lg">
        {/* <div onClick={onClose} className="w-full flex justify-end cursor-pointer">
            <CloseIcon />
          </div> */}
        <div className="">
          <h1 className="font-semibold text-[20px] leading-[30px] mb-2 md:mb-4">
            {t("budget.deletePrompt")}
          </h1>
          <h1>
            You are about to delete an expense. This action cannot be{" "}
            <br className="hidden md:flex" />
            reversed once confirmed.
          </h1>
        </div>
        <div className="flex justify-end items-end gap-6 mt-8">
          <button
            className="md:w-[210px] w-full  rounded-[4px] h-[48px] text-gray-700 font-semibold border border-gray-300"
            onClick={handleKeepExpense}
          >
            Cancel
          </button>
          <button
            className="md:w-[310px] w-full rounded-[4px] h-[48px] bg-[#D92D20] text-white font-semibold"
            onClick={() => handleDeleteExpense(expenseId)}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Yes, delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export { ExpenseDeletePrompt };
